import React from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

const InvisibleInput = styled.input.attrs({
  type: 'checkbox',
})<{
  isIndeterminate?: boolean;
  isDisabled?: boolean;
}>`
  display: none;

  &:checked + label {
    background: ${({ theme }) => theme.colors.primaryBg};
  }
  &:indeterminate + label {
    background: ${({ theme }) => theme.colors.primaryBg};
  }

  & + label:before {
    color: ${({ theme }) => theme.colors.textActive};
    font-family: FontAwesome !important;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-self: center;
    align-self: center;
    transform: translateY(1px);
  }
  &:checked + label:before {
    content: '\\f00c';
  }
  &:indeterminate + label:before {
    content: '\\f068';
  }
`;

const Label = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: center;
  align-self: center;
  width: 16px;
  height: 16px;
  transition: all 0.3s ease-in-out;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.bgActive};
  margin: 0;

  &:hover {
    border-color: ${({ theme }) => theme.colors.textPlaceholder};
  }
  cursor: pointer;
`;

export default function Checkbox({
  isChecked,
  isIndeterminate,
  isDisabled,
  onChange,
}: {
  isChecked: boolean;
  isIndeterminate?: boolean;
  isDisabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const id = React.useMemo(() => uuidv4(), []);
  const ref = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (typeof isIndeterminate === 'boolean' && ref.current) {
      ref.current.indeterminate = !isChecked && isIndeterminate;
    }
  }, [ref, isIndeterminate, isChecked]);

  return (
    <>
      <InvisibleInput
        id={id}
        ref={ref}
        checked={isChecked}
        isDisabled={isDisabled}
        onChange={onChange}
      />
      <Label htmlFor={id} />
    </>
  );
}
